import styled, { css } from 'styled-components';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';
import Icon from '@nubank/nuds-web/components/Icon/Icon';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const StyledIcon = styled(Icon)`
  flex-shrink: 0;
  margin-right: ${spacing('2x')};
  margin-top: ${spacing('1x')};

  ${breakpointsMedia({
    md: css`
      display: none;
    `,
    lg: css`
      display: inline;
    `,
  })}
`;

StyledIcon.displayName = 'StyledIcon';
